import { enumPanelBorderStyle, kFramelessBorderThickness, kFramelessPanelSize } from "../constants";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { QPanel } from "./QPanel";

export class QFramelessPanel extends QPanel {
  constructor() {
    super();
    this.fWSMgr = null;
    this.fButtonArray = [];
    this.fFramelessPanel = null;
  }

  InitFramelessPanel(wsMgr, xPos, yPos) {
    this.fWSMgr = wsMgr;
    this.SizePanel(kFramelessPanelSize[0], kFramelessPanelSize[1]);
    this.SetModalOn(false);

    var panelPos = this.GetPanelPosition(xPos, yPos);
    this.PositionPanel(panelPos.x, panelPos.y);

    this.SetFillColor(uFramelessPanelColor);
    this.SetBorderStyle(enumPanelBorderStyle.noBorder);
    this.SetBorderThickness(kFramelessBorderThickness);
    wsMgr.fFramelessPanel.push(this);
    wsMgr.PushPanel(this);
  }

  GetPanelPosition(xPos, yPos) {
    return { x: xPos, y: yPos };
  }
}
